import { render, staticRenderFns } from "./SupervisorDashboard3.vue?vue&type=template&id=2a2bc060&scoped=true&"
import script from "./SupervisorDashboard3.vue?vue&type=script&lang=js&"
export * from "./SupervisorDashboard3.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorDashboard3.vue?vue&type=style&index=0&id=2a2bc060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2bc060",
  null
  
)

export default component.exports